import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { ChartData, ChartOptions, Chart, registerables } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { ImportsModule } from "../../imports.module";
import { HomeService } from '../../services/home.service';
import { Colaborador, Beneficiario, Usuario } from '../../models';
import { SubirArchivosBeneficiarioComponent } from '../subir-archivos-beneficiario/subir-archivos-beneficiario.component';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { finalize, lastValueFrom, Subject, takeUntil } from 'rxjs';
import { PerfilStore } from '../../store/perfil.store';
import { Router } from '@angular/router';
import { CatalogosService } from '../../services/catalogos.service';
@Component({
  selector: 'app-reporte-detalle-saldos',
  standalone: true,
  imports: [CommonModule, NzDescriptionsModule, NzIconModule, NzTableModule, NzButtonModule, BaseChartDirective, ImportsModule],
  templateUrl: './reporte-detalle-saldos.component.html',
  styleUrl: './reporte-detalle-saldos.component.scss'
})
export class ReporteDetalleSaldosComponent implements OnInit {
  @Input() IdUser ?: number | null;
  @Output() regresar : EventEmitter<void> = new EventEmitter<void>();
  isLoading: boolean = false;
  isLoadingBeneficiarios: boolean = false;
  isLoadingHistogram: boolean = false;
  user : Usuario | null = null;
  $onDestroy: Subject<void> = new Subject<void>();
  DatosColaborador: Colaborador = {};
  beneficiarios : Beneficiario[] = [];
  resumenSaldos: any[] = [];
  NoAcceso: boolean = false;
  simpleChartData: ChartData<'bar'> = {
    labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    datasets: [
      {
        label: '',
        data: [],
        backgroundColor: this.setColor('#FFe5e8', 12),
        borderColor: this.setColor('#FF3B52', 12),
        borderWidth: 2
      }
    ]
  };

  simpleChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      title: {
        display: false
      },
      legend: {
        display: false
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Meses'
        }
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Monto Aprobado(MXN)'
        },
        ticks: {
          callback: function(value) {
            return '$' + value.toLocaleString();
          }
        }
      }
    }
  };



  constructor( private homeService: HomeService, private drawerService: NzDrawerService, private sessionStore: PerfilStore, private router: Router, private cdr: ChangeDetectorRef, private catalogos: CatalogosService ) {
    Chart.register(...registerables);
  }



  ngOnInit() {
    this.ObtenerDetalleColaborador();
    this.ObtenerDetalleBeneficiarios();
    this.ObtenerResumenSaldos();
    this.obtenerPeriodo();
    this.getUser();
  }

    async obtenerPeriodo() {
      try {
        let ResPeriodos = await lastValueFrom(this.catalogos.obtenerCatalogoCalendario());
        if (ResPeriodos?.details && Array.isArray(ResPeriodos.details)) {
          this.evaluarAccesoPorFecha(ResPeriodos.details);
        }
      } catch (error) {
        console.error('Error al obtener periodos:', error);
        this.NoAcceso = true;
      }
    }
  
    evaluarAccesoPorFecha(periodos: any[]) {
      const fechaActual = new Date();
      const mesActual = fechaActual.getMonth() + 1;
      const añoActual = fechaActual.getFullYear();
      if(mesActual === 1 ) {
        this.NoAcceso = fechaActual > new Date('01/24/' + añoActual);
      }
      else if (mesActual >= 2 && mesActual <= 12) {
        const fechaLimite = new Date(periodos.find(periodo => 
          periodo.mesContable?.toLowerCase() === 'diciembre'
        )?.limiteInfoColaborador || '12/10/' + añoActual);
        if (fechaLimite) {
          this.NoAcceso = fechaActual < fechaLimite;
        } else {
          this.NoAcceso = false;
        }
      } else {
        this.NoAcceso = false;
      }
    }

  getUser() {
    this.sessionStore.getPerfil()
    .pipe(takeUntil(this.$onDestroy))
    .subscribe((user:Usuario | null) => {
      this.user = user;
      if(!this.user?.esAdmin && !this.user?.esRRHH && !this.user?.esColaborador && !this.user?.esMedico){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
      }
    });
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  AjusteSaldos(data: Colaborador[]): Colaborador {
    let res = data.find((item: Colaborador) => item.tipoSaldoId === 1) || null;
    let gest = data.find((item: Colaborador) => item.tipoSaldoId === 2) || null;
    if(!res && !gest && data.length > 0) {
      res = data[0];
    }
    let DatosColaborador = {
    colaboradorId: res?.colaboradorId || gest?.colaboradorId,
    numeroEmpleado: res?.numeroEmpleado || gest?.numeroEmpleado,
    nombres: res?.nombres || gest?.nombres,
    apellidos: res?.apellidos || gest?.apellidos,
    fechaNacimiento: res?.fechaNacimiento || gest?.fechaNacimiento,
    sociedadId: res?.sociedadId || gest?.sociedadId,
    sociedadNombre: res?.sociedadNombre || gest?.sociedadNombre,
    divisionId: res?.divisionId || gest?.divisionId,
    divisionNombre: res?.divisionNombre || gest?.divisionNombre,
    correoKof: res?.correoKof || gest?.correoKof,
    generoCodigo: res?.generoCodigo || gest?.generoCodigo,
    generoDescripcion: res?.generoDescripcion || gest?.generoDescripcion,
    fechaAltaBeneficio: res?.fechaAltaBeneficio || gest?.fechaAltaBeneficio,
    tipoSaldoId: res?.tipoSaldoId || gest?.tipoSaldoId,
    tipoSaldoCodigo: res?.tipoSaldoCodigo || gest?.tipoSaldoCodigo,
    saldoRestante: res?.saldoRestante,
    saldoUtilizado: res?.saldoUtilizado,
    saldoTotal: res?.saldoTotal,
    saldoRestanteGestante: gest?.saldoRestante,
    saldoUtilizadoGestante: gest?.saldoUtilizado,
    saldoTotalGestante: gest?.saldoTotal
    };
    return DatosColaborador || {} as Colaborador;
  }


  ObtenerDetalleColaborador() {
    this.isLoading = true;
    this.homeService.obtenerDetalleUsuario(this.IdUser!)
    .pipe(
      takeUntil(this.$onDestroy),
      finalize(() => {
        this.isLoading = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe(
      {
        next: (res:any) => {
          let data = this.AjusteSaldos(res?.details);

          this.DatosColaborador = data as Colaborador;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error('Error al obtener el detalle del colaborador:', error);
        }
      }
    );
  }

  ObtenerDetalleBeneficiarios() {
    this.isLoadingBeneficiarios = true;
    this.homeService.obtenerDetalleBeneficiarios(this.IdUser!)
    .pipe(
      takeUntil(this.$onDestroy),
      finalize(() => {
        this.isLoadingBeneficiarios = false;
        this.cdr.detectChanges();
      })
    )
    .subscribe(
      {
        next: (res) => {
          let data = res?.details;
          this.beneficiarios = data as Beneficiario[];
        },
        error: (error) => {
          console.error('Error al obtener el detalle del colaborador:', error);
        }
      }
    );
  }

  ObtenerResumenSaldos() {
    this.isLoadingHistogram = true;
    this.homeService.obtenerDetalleSaldos(this.IdUser!)
    .pipe( takeUntil(this.$onDestroy),
    finalize(() => {
      this.isLoadingHistogram = false;
      this.cdr.detectChanges();
    })
  )
    .subscribe({
      next: (res: any) => {
        if (res?.success && res?.details) {
          this.resumenSaldos = res.details;          
          this.actualizarGrafico();
        }
      },
      error: (error) => {
        console.error('Error al obtener el detalle de saldos:', error);
      }
    });
  }

  private actualizarGrafico() {
    const saldoAprobadoData = this.resumenSaldos.find(item => item.concepto === 'Saldo Aprobado');
    if (saldoAprobadoData) {
      const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 
                     'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
      
      const datos = meses.map(mes => {
        const valor = saldoAprobadoData[mes];
        if (typeof valor === 'string') {
          return parseFloat(valor.replace(/[$,\s]/g, '')) || 0;
        }
        return valor || 0;
      });

      this.simpleChartData = {
        ...this.simpleChartData,
        datasets: [{
          ...this.simpleChartData.datasets[0],
          data: datos
        }]
      };
    }
  }
  tieneGestante(): boolean {
    return this.beneficiarios.some(beneficiario => beneficiario.esGestante === true);
  }

  registroGestante(beneficiario : Beneficiario): boolean {
    return beneficiario.esGestante === true;
  }

  obtenerSaldoGestante() { 
    const gestante = this.beneficiarios.find(beneficiario => beneficiario.esGestante === true);
    return gestante ? gestante.saldoGestante : 0;
  }

  AddBeneficiario(){
    const drawer = this.drawerService.create(
      {
        nzContent: SubirArchivosBeneficiarioComponent,
        nzData: null,
        nzWidth: 600
      }
    );
  }

  volver() {
    this.regresar.next();
  }

  setColor( color: string, length : number){
    return Array(length).fill(color);
  }

  mostrarInfo( name : string | undefined | null) {
    return !name?.includes('Colaborador');
  }

  AddSolicitud() {
    this.router.navigate(['/consulta-sgmm']);
  }
}